import React, { Component } from "react";
import {
  Box,
  TextField,
  Typography,
  Card,
  CardContent,
  CardMedia,
  InputAdornment,
  IconButton,
  Button,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { CartContext } from "../../comp/CartContext";
import { WithRouter } from "../../comp/WithRouter";

class Busca extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      searchTerm: "",
      filteredProducts: [],
    };
  }

  handleSearch = (event) => {
    const text = event.target.value;
    const products = this.context?.data?.products || [];

    const filtered = products.filter((product) =>
      product.name.toLowerCase().includes(text.toLowerCase())
    );

    this.setState({
      searchTerm: text,
      filteredProducts: text === "" ? [] : filtered,
    });
  };

  clearSearch = () => {
    this.setState({ searchTerm: "", filteredProducts: [] });
  };

  render() {
    const { searchTerm, filteredProducts } = this.state;

    return (
      <Box sx={{ bgcolor: "#f5f5f5", minHeight: "100vh" }}>
        {/* Header de Busca fiel à imagem */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            p: 1,
            bgcolor: "white",
            borderBottom: "1px solid #ddd",
          }}
        >
          <SearchIcon sx={{ color: "#999", ml: 1 }} />
          <TextField
            variant="standard"
            fullWidth
            placeholder="Pesquise por um produto"
            value={searchTerm}
            onChange={this.handleSearch}
            InputProps={{
              disableUnderline: true,
              sx: { ml: 2, fontSize: "1.1rem" },
            }}
          />
          {searchTerm && (
            <Button
              onClick={this.clearSearch}
              sx={{
                color: "#999",
                fontWeight: "bold",
                minWidth: "auto",
                mr: 1,
              }}
            >
              LIMPAR
            </Button>
          )}
          <IconButton
            onClick={() => {
              this.props.navigate(-1);
            }}
          >
            <ClearIcon sx={{ color: "#999" }} />
          </IconButton>
        </Box>

        {/* Container dos Cards */}
        <Box sx={{ p: 1.5 }}>
          {filteredProducts.map((product) => (
            <Card
              key={product.uuid || product.slug}
              sx={{
                display: "flex",
                mb: 1.5,
                borderRadius: "12px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                border: "1px solid #eee",
                height: 140, // Altura fixa para manter o padrão da imagem
                overflow: "hidden",
              }}
              onClick={() => {
                this.props.navigate(`/produto/${product.slug}`);
              }}
            >
              <CardContent
                sx={{
                  flex: 1,
                  p: 2,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Box>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", color: "#333", lineHeight: 1.2 }}
                  >
                    {product.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: "#888", mt: 0.5, fontSize: "0.9rem" }}
                  >
                    {product.description ||
                      (product.categoryId === 9 ? "Garrafa" : "")}
                  </Typography>
                </Box>

                <Typography
                  variant="h6"
                  sx={{ color: "#333", fontWeight: 500 }}
                >
                  {product.price > 0
                    ? `R$ ${product.price.toLocaleString("pt-br", {
                        minimumFractionDigits: 2,
                      })}`
                    : "A partir de R$ 31,00"}
                </Typography>
              </CardContent>

              {/* Imagem à Direita */}
              <Box sx={{ p: 1.5, display: "flex", alignItems: "center" }}>
                <CardMedia
                  component="img"
                  sx={{
                    width: 100,
                    height: 100,
                    borderRadius: "12px",
                    objectFit: "cover",
                    bgcolor: "#f0f0f0",
                  }}
                  image={
                    product.photos?.[0]?.name
                      ? `api/store/photo/${product.photos[0].name}`
                      : "https://via.placeholder.com/100?text=Sem+Foto"
                  }
                  alt={product.name}
                />
              </Box>
            </Card>
          ))}

          {searchTerm !== "" && filteredProducts.length === 0 && (
            <Typography sx={{ textAlign: "center", mt: 4, color: "#999" }}>
              Nenhum produto encontrado.
            </Typography>
          )}
        </Box>
      </Box>
    );
  }
}

export default WithRouter(Busca);
